import { Button } from '@chakra-ui/react';
import { memo, ReactNode, useCallback, useEffect, useState } from 'react';
import { FaFilter } from 'react-icons/fa6';

import { Dialog } from '../../modals/dialog';
import { TableColumn, TableFilter } from '../types';
import { FilterItem } from './filter-item';


type TableFilterProps<I extends EntityBase = EntityBase> = {
  isOpen: boolean;
  title: ReactNode;
  columns: TableColumn<I>[];
  filters: TableFilter<I>[];
  onClose(): void;
  onFilterSubmit(filters: TableFilter<I>[]): void;
}

export function TableFilterDialog<I extends EntityBase = EntityBase>({ isOpen, title, filters, columns, onClose, onFilterSubmit }: TableFilterProps<I>){
  const [filterValues, setFilterValues] = useState<TableFilter<I>[]>(filters || []);

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    setFilterValues(filters || []);
 
  }, [isOpen, columns, filters]);

  const onChangeValue = useCallback((newValue: TableFilter<I>) => {
    setFilterValues((filters) => filters
      .map((filter) => filter.name === newValue.name ? newValue : filter));
  }, []);

  const onClearValue = useCallback((name: string) => {
    setFilterValues((filters) => filters
      .map((filter) => filter.name === name ? { 
        ...filter, 
        value: filter.type === 'multi-select' || filter.type === 'date-range' ? [] : '',
      } : filter));
  }, []);

  return <Dialog open={isOpen}
    onClose={onClose}
    title={<><FaFilter fill='var(--chakra-colors-gray-500)' />{`Фильтр: ${title}`}</>}
    actions={<>
      <Button colorScheme='brand' mr={3} onClick={() => onFilterSubmit(filterValues)}>
        Применить
      </Button>
      <Button variant='ghost' onClick={onClose}>Закрыть</Button>
    </>}
  >
    {filterValues?.map((filter) => <FilterItem<I>
      key={filter.name.toString()}
      filter={filter}
      onChange={onChangeValue} 
      onClear={onClearValue}
    />)}
  </Dialog>;
}